const Passthrough = {
  pt: {
    global: {
      css: `
                .p-button {
                    background-color: var(--button-primary);
                    color: var(--button-primary-text);
                }
                .p-button-secondary {
                    background-color: var(--button-secondary);
                    color: var(--button-secondary-text);
                }
                .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight{
                    color: var(--dark);
                    background: var(--light);
                }
                .p-inputtext:enabled:focus, .p-dropdown:not(.p-disabled).p-focus{
                    box-shadow: inset 0 0 0 1px var(--highlight);
                    border-color: var(--highlight);
                }
                .p-float-label input:focus ~ label, .p-float-label .p-inputwrapper-focus ~ label, .p-float-label textarea:focus ~ label {
                    color: var(--highlight);
                }
                .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider{
                    background: var(--green-light);
                }
                .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before{
                    background: var(--green);
                }
                .p-tabmenu .p-tabmenu-nav .p-tabmenu-ink-bar{
                    background: var(--highlight);
                }
                .p-tabmenu .p-tabmenu-nav li .p-menuitem-link:focus, 
                .p-tabmenu .p-tabmenu-nav .p-tabmenuitem:not(.p-highlight):not(.p-disabled):hover .p-menuitem-link,
                .p-tabmenu .p-tabmenu-nav li.p-highlight .p-menuitem-link:focus{
                    background: var(--light);
                }
                .p-tabmenu .p-tabmenu-nav, .p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link{
                    background: none;
                    border: none;
                }
                .p-checkbox .p-checkbox-box.p-highlight, .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover{
                    border-color: var(--green);
                    background: var(--green);
                }
                .p-fileupload-file-actions .p-button{
                    background: var(--light);
                }
                .p-progressbar{
                    background: var(--light);
                }
                .p-fileupload .p-fileupload-content.p-fileupload-highlight{
                    border: 1px dashed var(--dark);
                    background: var(--light);
                }
                .p-fileupload-file-thumbnail{
                    display: none;
                }
                .p-fileupload-file-badge{
                    display: none;
                }
                .p-fileupload .p-button{
                    border-radius: 20px
                }
                .p-tag{
                    font-size: 1em;
                    padding: 3px 15px;
                }
                .p-tag.p-tag-info{
                    background: var(--light);
                    color: var(--dark)
                }
                .p-tag.p-tag-success{
                    background: var(--green-light);
                    color: var(--green);
                }
                .p-tag.p-tag-warning{
                    background: var(--yellow-light);
                    color: var(--yellow-dark);
                }
                .p-tag.p-tag-contrast{
                    background: var(--green-light);
                    color: var(--green);
                }
                .p-tag.p-tag-danger{
                    background: var(--red-light);
                    color: var(--red);
                }
                .p-tag.p-tag-warn{
                    background: var(--yellow-light);
                    color: #000;
                }
                .p-steps .p-steps-item.p-highlight .p-steps-number{
                    background-color: var(--highlight);
                }
                .p-tooltip-text{
                    background: #303030;
                    font-size: 1em;
                }
                .p-avatar{
                    min-width: 2rem;
                }
                .p-avatar.p-avatar-lg { 
                    font-size: 18px;
                    min-width: 3rem;
                }
                .p-avatar.p-avatar-xl{
                    font-size: 24px;
                    min-width: 4rem;
                }
                .p-rowgroup-header td{
                    background: var(--light);;
                }
                .p-multiselect:not(.p-disabled).p-focus{
                    box-shadow: inset 0 0 0 1px var(--highlight);
                    border-color: var(--highlight);
                }
                .p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight{
                    color: var(--dark);
                    background: var(--light);
                }
                .p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item.p-highlight{
                    color: var(--dark);
                    background: var(--light);
                }
                .p-datepicker table td.p-datepicker-today > span.p-highlight, .p-datepicker table td > span.p-highlight{
                    color: var(--dark);
                    background: var(--light);
                }
                .p-paginator .p-paginator-pages .p-paginator-page.p-highlight{
                    color: var(--dark);
                    background: var(--light);
                }
            `,
    },
  },
};

export default Passthrough;
